<!--Footer Starts-->
<footer class="footer">
  <img src="assets/img/logos/logoavancer_gris.png" style="display: block; margin:auto; width:15rem;">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} SIGA
    <span class="d-none d-sm-inline-block">, Todos los derechos reservados.</span>
  </p>
</footer>
<!--Footer Ends-->

<div class="row">
  <app-tabs></app-tabs>
</div>
